import React from "react";
import ReactAudioPlayer from "react-audio-player";

import style from "@/components/AudioPlayer.module.scss";

const AudioPlayer = ({ file }) => {
  if (!file) return null;

  return (
    <div className={style.root}>
      <ReactAudioPlayer src={file.url} controls className={style.player} />
    </div>
  );
};

export default AudioPlayer;
